
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";
import { LogEntry, LogType } from "@/models/log";
import { logJsonAndGoKeys } from "@/utils/browse/log-keys";

export default Vue.extend({
	props: {
		logs: {
			type: Array as () => LogEntry[],
			required: true
		},
		selected: {
			type: Array as () => LogEntry[],
			required: true
		},
		order: {
			type: String,
			required: true
		},
		orderAscending: {
			type: Boolean
		}
	},
	computed: {
		// eslint-disable-next-line max-lines-per-function
		columns(): IDataTableColumn[] {
			let formatTimeUnit = this.formatTimeUnit;
			return [
				{
					name: "ID",
					property: "id",
					width: "80px",
				},
				{
					name: "Dossier ID",
					property: "dossierId",
					width: "80px"
				},
				{
					name: "User ID",
					property: "userId",
					width: "80px"
				},
				{
					name: "Time Stamp",
					property: "timeStamp",
					print(val: Date): string {
						let timePart = `${formatTimeUnit(val.getHours())}:${formatTimeUnit(val.getMinutes())}`;
						let datePart = `${formatTimeUnit(val.getDate())}/${formatTimeUnit(val.getMonth()+1)}/${val.getFullYear()}`;
						return `${timePart} ${datePart}`;
					}
				},
				{
					name: "Type",
					property: "logType",
					print(val: LogType): string {
						if (val == LogType.INFO) {
							return "Info";
						}
						if (val == LogType.WARN) {
							return "Waarschuwing";
						}
						return "Error";

					}
				},
				{
					name: "Message",
					property: "message",
					width: "800px"
				},
				{
					name: "Stack",
					property: "stack",
					width: "1000px"
				},
			];
		},
		orderedColumnProperty(): string {
			for (let key of Object.keys(logJsonAndGoKeys)) {
				if (logJsonAndGoKeys[key] == this.order) {
					return key;
				}
			}
			return "this.ID";
		}
	},
	methods: {
		onOrder({ascending, order}: { ascending: boolean, order: string }) {
			this.$emit("order", {order: logJsonAndGoKeys[order], ascending});
		},
		openLog(item:LogEntry){
			this.$emit("open-log",item);
		},
		formatTimeUnit(value:number):string {
			if (`${value}`.length == 1) {
				return `0${value}`;
			}
			return `${value}`;
		},
	}
});
